import { Info, CheckCircle, Error } from '@material-ui/icons';

export const MARKS = {
  BOLD: 'BOLD',
  ITALIC: 'ITALIC',
  UNDERLINE: 'UNDERLINE',
  FONT_SIZE: 'FONT_SIZE',
  LINE_HEIGHT: 'LINE_HEIGHT',
  FONT_COLOR: 'FONT_COLOR',
};

export const NODES = {
  DIV: 'DIV',
  SPAN: 'SPAN',
  PARAGRAPH: 'PARAGRAPH',
  PARAGRAPH_LEFT: 'PARAGRAPH_LEFT',
  PARAGRAPH_RIGHT: 'PARAGRAPH_RIGHT',
  PARAGRAPH_CENTER: 'PARAGRAPH_CENTER',
  PARAGRAPH_JUSTIFY: 'PARAGRAPH_JUSTIFY',
  IMAGE: 'IMAGE',
  LINK: 'LINK',
  ORDERED_LIST: 'ORDERED_LIST',
  UNORDERED_LIST: 'UNORDERED_LIST',
  LIST_ITEM: 'LIST_ITEM',
  TABLE: 'TABLE',
  TABLE_ROW: 'TABLE_ROW',
  TABLE_CELL: 'TABLE_CELL',
  SNIPPET: 'SNIPPET',
  TRANSLATION: 'TRANSLATION',
  VIDEO: 'VIDEO',
  SNIPPET_BUTTON: 'SNIPPET_BUTTON',
  HEADING_2: 'HEADING_2',
  HEADING_3: 'HEADING_3',
  HEADING_4: 'HEADING_4',
  HEADING_5: 'HEADING_5',
  HEADING_6: 'HEADING_6',
};

export const LINK_TYPES = {
  EXTERNAL: 'EXTERNAL',
  ARTICLE: 'ARTICLE',
};

export const LINK_TARGETS = {
  SAME_WINDOW: '_self',
  NEW_WINDOW: '_blank',
};

export const DEFAULT_COLOR = 'rgb(26, 26, 26)';

export const COLOR_OPTIONS = [
  'rgb(26, 188, 156)',
  'rgb(46, 204, 113)',
  'rgb(52, 152, 219)',
  'rgb(155, 89, 182)',
  'rgb(78, 95, 112)',
  'rgb(241, 196, 15)',
  'rgb(22, 160, 133)',
  'rgb(39, 174, 96)',
  'rgb(41, 128, 185)',
  'rgb(142, 68, 173)',
  'rgb(44, 62, 80)',
  'rgb(243, 156, 18)',
  'rgb(230, 126, 34)',
  'rgb(231, 76, 60)',
  'rgb(236, 240, 241)',
  'rgb(149, 165, 166)',
  'rgb(221, 221, 221)',
  'rgb(255, 255, 255)',
  'rgb(211, 84, 0)',
  'rgb(192, 57, 43)',
  'rgb(189, 195, 199)',
  'rgb(127, 140, 141)',
  'rgb(153, 153, 153)',
  'rgb(0, 0, 0)',
];

export const FONT_SIZE_OPTIONS = [
  'Default',
  8,
  9,
  10,
  11,
  12,
  14,
  16,
  18,
  20,
  22,
  24,
  26,
  28,
  36,
  48,
  72,
];

export const LINE_HEIGHT_OPTIONS = [
  'Default',
  1,
  1.1,
  1.2,
  1.3,
  1.4,
  1.5,
  1.6,
  1.7,
  1.8,
  1.9,
  2,
  2.5,
  3,
  3.5,
  4,
];

export const HEADINGS_OPTIONS = ['Default', 2, 3, 4, 5, 6];

export const NOTIFICATIONS = {
  TYPE: {
    ERROR: 'ERROR',
    SUCCESS: 'SUCCESS',
    INFO: 'INFO',
  },
  TITLE: {
    ERROR: 'Oops!',
    SUCCESS: 'Yay!',
    INFO: 'Info',
  },
  ICON: {
    ERROR: Error,
    SUCCESS: CheckCircle,
    INFO: Info,
  },
  COLOR: {
    ERROR: '#ce3535',
    SUCCESS: '#0f7e4a',
    INFO: '#0062b4',
  },
};

export const COUNTRY_MARKET_GROUP = [
  {
    country: '01924c48-49bb-40c2-9c32-ab582e6db6f4',
    languages: ['de-DE', 'en-GB'],
  },
  {
    country: '53075bd4-0205-4b5d-8145-e7a7745ab137',
    languages: ['de-AT', 'en-GB'],
  },
  {
    country: 'c2bd90da-0090-4751-8f16-35dea7002071',
    languages: ['de-CH', 'fr-CH', 'it-CH', 'en-GB'],
  },
  {
    country: '733af55a-4133-4d7c-b5f3-d64d42c135fe',
    languages: ['fr-FR', 'en-GB'],
  },
  {
    country: '043ec789-a3c7-4556-92df-bf1845c741ab',
    languages: ['fr-BE', 'nl-BE', 'en-GB'],
  },
  { country: '83c4e87f-6819-41bb-af61-46cddb8453f5', languages: ['en-GB'] },
  { country: 'a13a1960-5d57-4c51-a3ea-7e8d28e2c0b7', languages: ['en-IE'] },
  {
    country: '00f2a393-6889-4fc0-8cd9-86e454e6dfa3',
    languages: ['nl-NL', 'en-GB'],
  },
  {
    country: 'ebf57ebf-e26d-4ebd-8009-6ad519073d2a',
    languages: ['it-IT', 'en-GB'],
  },
  {
    country: 'ca9d5f22-2a1b-4799-b3b7-83f47c191489',
    languages: ['pl-PL', 'en-GB'],
  },
  { country: '1e161d6e-0427-4cfc-a357-e2b501188a15', languages: ['es-ES'] },
  {
    country: '091dcbdd-7839-4f39-aa05-324eb4599df0',
    languages: ['sv-SE', 'en-GB'],
  },
  { country: 'ef064ea7-1d91-442c-bcbb-9d20749af19b', languages: ['no-NO'] },
  { country: 'aadd3adf-500f-4372-8137-dc0e4b2f0582', languages: ['fi-FI'] },
  {
    country: '7ce94f55-7a4d-4416-95c1-bf34193a47e8',
    languages: ['da-DK', 'en-GB'],
  },
  { country: 'b773b421-c719-4dfd-afc8-e97da508a88d', languages: ['cs-CZ'] },
  { country: '371e627a-2c44-4dbd-8e63-3344327a25c1', languages: ['sk-SK'] },
  { country: 'b8949dea-af4e-42e7-8271-2e7b1bb123c5', languages: ['sl-SI'] },
  { country: '8a46930c-01ec-4027-98fd-23d304f247d6', languages: ['lt-LT'] },
  { country: '98478cb5-85f1-4775-a130-0b2413b1c4b8', languages: ['lv-LV'] },
  { country: '3d334e1f-112a-427f-96ae-e31948ed5163', languages: ['et-EE'] },
  { country: '8be9fe4a-397a-4bfb-9d1b-cfe7d01caf91', languages: ['hr-HR'] },
  { country: '4b8c533b-26b8-4c41-9a60-72a0df43d26f', languages: ['hu-HU'] },
  { country: '7fb9880f-de8d-4e56-bac1-5527da550a74', languages: ['ro-RO'] },
  {
    country: '5d99621e-7a9e-4393-8df3-1084ac3bb8a7',
    languages: ['pt-PT', 'en-GB'],
  },
  {
    country: '42dfb2d2-57fe-4653-a1f9-5576d0bdb497',
    languages: ['en-GB', 'de-DE', 'de-CH', 'fr-CH'],
  },
  {
    country: '8770f2e1-3452-41d5-99b2-eb7f7e069800',
    languages: ['fr-LU', 'de-LU', 'en-GB'],
  },
  {
    country: 'eedc88ca-8d43-4835-aac3-0766da92a02d',
    languages: ['el-GR', 'en-GB'],
  },
  {
    country: '3ccfb803-8cca-48eb-a1fd-f43fe7a549db',
    languages: ['bg-BG', 'en-GB'],
  },
];

export const SALESCHANNEL_NAME_MAP = {
  'c2bd90da-0090-4751-8f16-35dea7002071': 'Switzerland',
  '83c4e87f-6819-41bb-af61-46cddb8453f5': 'UK',
  'aadd3adf-500f-4372-8137-dc0e4b2f0582': 'Finland',
  '01924c48-49bb-40c2-9c32-ab582e6db6f4': 'Germany',
  '1e161d6e-0427-4cfc-a357-e2b501188a15': 'Spain',
  'ebf57ebf-e26d-4ebd-8009-6ad519073d2a': 'Italy',
  '733af55a-4133-4d7c-b5f3-d64d42c135fe': 'France',
  '043ec789-a3c7-4556-92df-bf1845c741ab': 'Belgium',
  '53075bd4-0205-4b5d-8145-e7a7745ab137': 'Austria',
  'b773b421-c719-4dfd-afc8-e97da508a88d': 'Czech',
  '7ce94f55-7a4d-4416-95c1-bf34193a47e8': 'Denmark',
  'a13a1960-5d57-4c51-a3ea-7e8d28e2c0b7': 'Ireland',
  'ca9d5f22-2a1b-4799-b3b7-83f47c191489': 'Poland',
  '091dcbdd-7839-4f39-aa05-324eb4599df0': 'Sweden',
  'ef064ea7-1d91-442c-bcbb-9d20749af19b': 'Norway',
  '00f2a393-6889-4fc0-8cd9-86e454e6dfa3': 'Netherlands',
  '371e627a-2c44-4dbd-8e63-3344327a25c1': 'Slovakia',
  'b8949dea-af4e-42e7-8271-2e7b1bb123c5': 'Slovenia',
  '8a46930c-01ec-4027-98fd-23d304f247d6': 'Lithuania',
  '98478cb5-85f1-4775-a130-0b2413b1c4b8': 'Latvia',
  '3d334e1f-112a-427f-96ae-e31948ed5163': 'Estonia',
  '8be9fe4a-397a-4bfb-9d1b-cfe7d01caf91': 'Croatia',
  '4b8c533b-26b8-4c41-9a60-72a0df43d26f': 'Hungary',
  '7fb9880f-de8d-4e56-bac1-5527da550a74': 'Romania',
  '5d99621e-7a9e-4393-8df3-1084ac3bb8a7': 'Portugal',
  '8770f2e1-3452-41d5-99b2-eb7f7e069800': 'Luxembourg',
  '42dfb2d2-57fe-4653-a1f9-5576d0bdb497': 'Dummy',
  'eedc88ca-8d43-4835-aac3-0766da92a02d': 'Greece',
  '3ccfb803-8cca-48eb-a1fd-f43fe7a549db': 'Bulgaria',
};

export const LOCALE_NAME_MAP = {
  'fr-CH': 'French',
  'fr-FR': 'French',
  'fr-BE': 'French',
  'fr-LU': 'French',
  'nl-NL': 'Dutch',
  'nl-BE': 'Dutch',
  'it-IT': 'Italian',
  'it-CH': 'Italian',
  'de-DE': 'German',
  'de-AT': 'German',
  'de-CH': 'German',
  'de-LU': 'German',
  'en-IE': 'English',
  'en-GB': 'English',
  'pl-PL': 'Polish',
  'no-NO': 'Norwegian',
  'es-ES': 'Spanish',
  'da-DK': 'Danish',
  'sv-SE': 'Swedish',
  'cs-CZ': 'Czech',
  'fi-FI': 'Finnish',
  'sk-SK': 'Slovak',
  'sl-SI': 'Slovenian',
  'lt-LT': 'Lithuanian',
  'lv-LV': 'Latvian',
  'et-EE': 'Estonian',
  'hr-HR': 'Croatian',
  'hu-HU': 'Hungarian',
  'ro-RO': 'Romanian',
  'pt-PT': 'Portuguese',
  'el-GR': 'Greek',
  'bg-BG': 'Bulgarian',
};

export const TIMEZONES = [
  { label: 'UTC -5', value: '-05:00' },
  { label: 'UTC -4', value: '-04:00' },
  { label: 'UTC -3', value: '-03:00' },
  { label: 'UTC -2', value: '-02:00' },
  { label: 'UTC -1', value: '-01:00' },
  { label: 'UTC', value: 'Z' },
  { label: 'UTC +1', value: '+01:00' },
  { label: 'UTC +2', value: '+02:00' },
  { label: 'UTC +3', value: '+03:00' },
  { label: 'UTC +4', value: '+04:00' },
  { label: 'UTC +5', value: '+05:00' },
];

export const CHANNEL_TYPES = {
  PHONE: 'PHONE',
  CHAT: 'CHAT',
  EMAIL: 'EMAIL',
  RASA_CHAT: 'RASA_CHAT',
  CHATBOT: 'CHATBOT',
};

export const CHANNEL_VARIANTS = {
  OFFICIAL: 'OFFICIAL',
  OVERRIDE: 'OVERRIDE',
};

export const CHANNEL_VARIANTS_LABEL = {
  OFFICIAL: 'Default',
  OVERRIDE: 'Override',
};

export const RESOURCE_STATES = {
  UNSAVED: 'UNSAVED',
  DRAFT: 'DRAFT',
  PUBLISHED: 'PUBLISHED',
  ARCHIVED: 'ARCHIVED',
};

export const OPERATION_TYPES = {
  CREATE: 'CREATE',
  UPDATE: 'UPDATE',
  DELETE: 'DELETE',
};

export const CHANNEL_DESTINATION_LABEL = {
  PHONE: 'Phone number',
  CHAT: 'Button id',
  RASA_CHAT: 'Chat URL',
  EMAIL: 'URL',
  CHATBOT: 'Button id',
};

export const CONTEXT_MAP = {
  SEGMENT: 'segment',
  LOYALTY_TIER: 'loyalty_tier',
  OCTOPUS_VARIANT: 'octopus_variant',
  LOGIN_STATUS: 'login_status',
  CHANNEL: 'channel',
  DEVICE: 'device',
  URL: 'url_key',
  PREMIUM_CUCA: 'premium_cuca',
  ARTICLE_SLUG: 'article_slug',
};

export const CHANNELING_CONTEXT_OPTIONS = [
  { label: 'Segment', value: CONTEXT_MAP.SEGMENT },
  { label: 'Loyalty tier', value: CONTEXT_MAP.LOYALTY_TIER },
  { label: 'Octopus variant', value: CONTEXT_MAP.OCTOPUS_VARIANT },
  { label: 'Login status', value: CONTEXT_MAP.LOGIN_STATUS },
  { label: 'Channel', value: CONTEXT_MAP.CHANNEL },
  { label: 'Device type', value: CONTEXT_MAP.DEVICE },
  { label: 'Url', value: CONTEXT_MAP.URL },
  { label: 'Premium CuCa', value: CONTEXT_MAP.PREMIUM_CUCA },
  { label: 'Slug', value: CONTEXT_MAP.ARTICLE_SLUG },
];

export const CONTEXT_FIELD_TYPE = {
  [CONTEXT_MAP.SEGMENT]: 'multi_select',
  [CONTEXT_MAP.LOYALTY_TIER]: 'multi_select',
  [CONTEXT_MAP.OCTOPUS_VARIANT]: 'free_text',
  [CONTEXT_MAP.LOGIN_STATUS]: 'multi_select',
  [CONTEXT_MAP.CHANNEL]: 'multi_select',
  [CONTEXT_MAP.DEVICE]: 'multi_select',
  [CONTEXT_MAP.URL]: 'free_text',
  [CONTEXT_MAP.PREMIUM_CUCA]: 'multi_select',
  [CONTEXT_MAP.ARTICLE_SLUG]: 'multi_select',
};

export const CONTEXT_VALUE_OPTIONS = {
  [CONTEXT_MAP.SEGMENT]: [
    { label: 'Plus', value: 'Plus' },
    { label: 'VIP', value: 'VIP' },
    { label: 'A', value: 'A' },
    { label: 'B', value: 'B' },
    { label: 'C', value: 'C' },
    { label: 'D', value: 'D' },
    { label: 'F', value: 'F' },
    { label: 'N', value: 'N' },
    { label: 'N/A', value: 'N/A' },
  ],
  [CONTEXT_MAP.LOYALTY_TIER]: [
    { label: 'Tier 1', value: 'TIER_1' },
    { label: 'Tier 2', value: 'TIER_2' },
    { label: 'Tier 3', value: 'TIER_3' },
    { label: 'Tier 4', value: 'TIER_4' },
  ],
  [CONTEXT_MAP.LOGIN_STATUS]: [
    { label: 'Hard', value: 'hard' },
    { label: 'Soft', value: 'soft' },
    { label: 'Not logged in', value: 'no_login' },
  ],
  [CONTEXT_MAP.CHANNEL]: [
    { label: 'desktop', value: 'desktop' },
    { label: 'mobile', value: 'mobile' },
    { label: 'app', value: 'app' },
  ],
  [CONTEXT_MAP.DEVICE]: [
    { label: 'not-app', value: 'not-app' },
    { label: 'ios', value: 'ios' },
    { label: 'android', value: 'android' },
  ],
  [CONTEXT_MAP.PREMIUM_CUCA]: [
    { label: 'Yes', value: 'yes' },
    { label: 'No', value: 'no' },
  ],
};

export const CONTEXT_GROUPS = {
  INCLUDE: 'context_inclusions',
  EXCLUDE: 'context_exclusions',
};

export const MARKET_LIST = COUNTRY_MARKET_GROUP.flatMap((item) => {
  return item.languages.map((language) => {
    return {
      label: `${SALESCHANNEL_NAME_MAP[item.country]} - ${
        LOCALE_NAME_MAP[language]
      }`,
      value: `${item.country},${language}`,
    };
  });
});

export const WEEKDAY_ORDER = [
  'MONDAY',
  'TUESDAY',
  'WEDNESDAY',
  'THURSDAY',
  'FRIDAY',
  'SATURDAY',
  'SUNDAY',
];

export const LIVE_STATES = {
  ONLINE: 'ONLINE',
  OFFLINE: 'OFFLINE',
};

export const SNIPPETS = [
  {
    title: 'OrderDetailHome',
    value: '<OrderDetailHome>OrderDetailHome</OrderDetailHome>',
  },
  { title: 'Login', value: '<Login>Login</Login>' },
  { title: 'OpenAmount', value: '<OpenAmount>OpenAmount</OpenAmount>' },
  {
    title: 'InvoiceLogin',
    value: '<InvoiceLogin>InvoiceLogin</InvoiceLogin>',
  },
  { title: 'ReturnButton', value: '<ReturnButton>ReturnButton</ReturnButton>' },
  {
    title: 'GenerateInvoiceLogin',
    value: '<GenerateInvoiceLogin>GenerateInvoiceLogin</GenerateInvoiceLogin>',
  },
  {
    title: 'VoucherBalanceLogin',
    value: '<VoucherBalanceLogin>VoucherBalanceLogin</VoucherBalanceLogin>',
  },
  {
    title: 'RedeemVoucher',
    value: '<RedeemVoucher>RedeemVoucher</RedeemVoucher>',
  },
  {
    title: 'ReclamationButton',
    value: '<ReclamationButton>ReclamationButton</ReclamationButton>',
  },
  {
    title: 'ManagePassword',
    value: '<ManagePassword>ManagePassword</ManagePassword>',
  },
  {
    title: 'OrderDetail',
    value: '<OrderDetail>OrderDetail</OrderDetail>',
  },
  {
    title: 'OrderCancellation',
    value: '<OrderCancellation>OrderCancellation</OrderCancellation>',
  },
  {
    title: 'GenerateInvoice',
    value: '<GenerateInvoice>GenerateInvoice</GenerateInvoice>',
  },
  {
    title: 'VoucherBalance',
    value: '<VoucherBalance>VoucherBalance</VoucherBalance>',
  },
  {
    title: 'ReturnTracking',
    value: '<ReturnTracking>ReturnTracking</ReturnTracking>',
  },
  {
    title: 'UpsReturnButton',
    value: '<UpsReturnButton>UpsReturnButton</UpsReturnButton>',
  },
];
